/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowfooter2Inputs */

const en_aiflowfooter2 = /** @type {(inputs: Aiflowfooter2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Covers never show real people, only graphics, type and your brand.`)
};

const de_aiflowfooter2 = /** @type {(inputs: Aiflowfooter2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Covers zeigen nie echte Menschen, nur Grafik, Schrift und deine Marke.`)
};

/**
* | output |
* | --- |
* | "Covers never show real people, only graphics, type and your brand." |
*
* @param {Aiflowfooter2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowfooter2 = /** @type {((inputs?: Aiflowfooter2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowfooter2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowfooter2(inputs)
	return de_aiflowfooter2(inputs)
});
export { aiflowfooter2 as "aiFlowFooter" }